import { gql } from "apollo-angular";
import { LINK_FIELDS } from "./link";

export const  FOOTER_FIELDS = gql`
  fragment FOOTER_FIELDS on WebsiteFooter {
    copyright
    cookieLink
    footerLogo {
      url
      description
    }
    tagLine
    socialLinksCollection (limit:8) {
      items {
        ... LINK_FIELDS
        cssClass
      }
    }
    buttonLink1 {
        ... LINK_FIELDS
    }
    buttonLink2 {
      ... LINK_FIELDS
    }
    linksCollection (limit:4) {
      items {
        ... LINK_FIELDS
      }
    }
    columnLinksCollection (limit:4) {
      items {
        cTitle
        linksCollection (limit:10) {
          items {
            ... LINK_FIELDS
          }
        }
      }
    }
  }
  ${LINK_FIELDS}`;
